<template>
    <UBadge
        size="sm"
        icon="i-ph-sparkle"
        label="AI"
        color="neutral"
        variant="subtle"
        class="w-fit"
        :ui="{
            base: 'bg-violet-100 text-violet-700 ring-violet-300',
        }"
    />
    <div class="grid grid-cols-2 gap-2 text-sm font-semibold">
        <template v-for="item in details" :key="item.label">
            <div >{{ item.label }}</div>
            <div class="text-right">{{ item.value || '' }}</div>
        </template>
    </div>
</template>

<script setup lang="ts">
import {SubAccountCreatable} from '@/assignments/SubAccountCreatable/SubAccountCreatable.type'
import {computed} from 'vue'

const props = defineProps({
    actionable: {
        type: Object as () => SubAccountCreatable,
        required: true
    }
})

const details = computed(() => [
    { label: 'Navn', value: props.actionable.name },
    { label: 'Org Nr.', value: props.actionable.orgNo },
    { label: 'Kontaktperson', value: props.actionable.contactInfo },
    { label: 'Adresse', value: props.actionable.address?.addressLine },
    { label: 'Postnummer', value: props.actionable.address?.postalCode },
    { label: 'Poststed', value: props.actionable.address?.postalLocation },
    { label: 'Land', value: props.actionable.address?.countryCode },
])

</script>

<style scoped>

</style>